import styled from 'styled-components';

export const Highlight = styled.span`
  & > span.highlight {
    /* background: yellow; */
    text-decoration: underline;
  }
`;
